import { useEffect } from 'react';
import io, { Socket } from 'socket.io-client';
import { CHAT_BACKEND_URL } from 'configs/env.conf';
import { useNotificationContext } from 'contexts/NotificationContext';
import { useChatUnread } from 'contexts/ChatUnreadContext';
import { useLocation } from 'react-router-dom';
import { getCurrentUserId } from 'utils/getCurrentUser';

const BACKEND_URL = CHAT_BACKEND_URL;
const SOCKET_URL = `${BACKEND_URL}/chat`;

let globalSocket: Socket | null = null;

const GlobalSocketListener = () => {
  const { changeNotification } = useNotificationContext();
  const { setHasUnreadChat } = useChatUnread();
  const location = useLocation();
  const userId = getCurrentUserId();

  useEffect(() => {
    if (!userId) return;
    if (globalSocket) return; // Đảm bảo chỉ tạo 1 socket toàn cục

    globalSocket = io(SOCKET_URL, {
      transports: ['websocket'],
      auth: {
        userId,
        token: `Bearer ${localStorage.getItem('token') || ''}`,
      },
    });

    globalSocket.on('connect', () => {});

    globalSocket.on('message', (data: any) => {});

    globalSocket.on('message_notification', (payload: any) => {
      // payload phải có đủ trường cho NotificationToast
      changeNotification({
        ...payload,
        createdAt: payload.timestamp || new Date().toISOString(),
        content: payload.message,
        id: payload.id || Date.now(),
        isRead: 0,
        type: 0,
        status: 0,
        contentId: 0,
        image: '',
        contentBold: null,
        readAt: '',
        skype: '',
        courseId: 0,
      });
      // Nếu không ở trang chat thì set unread chat
      if (!location.pathname.startsWith('/chat')) {
        setHasUnreadChat(true);
      }
    });

    return () => {
      globalSocket?.disconnect();
      globalSocket = null;
    };
  }, [userId]);

  return null;
};

export default GlobalSocketListener;
